import * as Yup from "yup";
import type { LicenseConfirmationItem } from "../../interfaces";
import { get } from "lodash";

export const licenseConfirmationValidationSchemas = (originalItems: LicenseConfirmationItem[]) =>
  Yup.array().of(
    Yup.object().shape({
      licensesCount: Yup.number()
        .required("Required")
        .min(0, "Cannot be negative")
        .max(5000000, "Number of Licenses can be maximum 5,000,000")
        .test("min-needed-licenses", function (value) {
          const path = this.path.replace(/licensesCount$/, "purchasingLicenses");
          const originalValue = get(originalItems, path);

          if (value >= originalValue) return true;

          return this.createError({
            message: `Enter a number equal to or greater than the licenses in use: <strong>${originalValue}</strong>`,
          });
        }),
    }),
  );
